import React, {Dispatch, SetStateAction, useState} from 'react';
import s from './SignIn.module.css'
// import attention from '../../../assets/newImg/attention.svg'
import MyBtn from "../../../components/ui/MyBtn/MyBtn";
import {useAppDispatch} from "../../../hooks/redux";
import {useFormik} from "formik";
import {motion} from 'framer-motion';
import {NavLink} from "react-router-dom";
import {getAdditionalsThunk} from "../../../store/reducers/ActionCreators";
import MyInput from "../../../components/ui/MyInput/MyInput";
import {setDisabled} from "../../../store/reducers/UserSlice";
import Steps from '../../../components/ui/Steps/Steps';

type LoginDataType = {
    email: string,
    password: string
    emailCode: string,
    twoFaCode: string,
    smsCode: string,
    sessionStart: string;
}

type PropsType = {
    setCurrent: Dispatch<SetStateAction<number>>
    setLoginData: Dispatch<SetStateAction<LoginDataType>>
    setAdditionalSettings: Dispatch<SetStateAction<any>>
    current?: number
    dataForSend: LoginDataType
    validErrors: string[]
}

const SignIn = (props: PropsType) => {

    const dispatch = useAppDispatch()
    const [isAuthSuccess, setIsAuthSuccess] = useState(true)
    const [errorMessage, setErrorMessage] = useState<string>("")

    const formikLogin = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        onSubmit: async values => {
            dispatch(setDisabled(true))
            await dispatch(getAdditionalsThunk(values))
                .then((res) => {
                    props.setAdditionalSettings(res.data)
                    props.setLoginData(
                        {...props.dataForSend,
                            email: values.email,
                            password: values.password,
                        }
                    )
                    props.setCurrent(1)
                }).catch((e) => {
                    for (let i = 0; i < props.validErrors.length; i++) {
                        if (props.validErrors[i] === e.response.data) {
                            setErrorMessage(e.response.data)
                            break;
                        }
                        setErrorMessage("Oops, something went wrong. Please try again later")
                    }
                    setIsAuthSuccess(false)
                })
            dispatch(setDisabled(false))
        }
    })

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >
            <div className={s.sign_in_wrapper}>
                <form autoComplete="off" onSubmit={formikLogin.handleSubmit} className={s.sign_in_form}>
                    <div className={s.sign_in_content}>
                        <div className={s.title}>
                            Sign In
                        </div>
                        {
                            !isAuthSuccess &&
                            <div className={s.error_block}>
                                {/*<img src={attention} alt=""/>*/}
                                <div>
                                    {errorMessage}
                                </div>
                            </div>
                        }
                        <div className={s.input_block}>
                            <div className={s.input_label}>
                                email address
                            </div>
                            <MyInput
                                   id="email"
                                   name="email"
                                   value={formikLogin.values.email}
                                   onChange={formikLogin.handleChange}
                            />
                        </div>
                        <div className={s.input_block}>
                            <div className={s.input_label}>
                                password
                            </div>
                            <MyInput id="password"
                                     name="password"
                                     password
                                     value={formikLogin.values.password}
                                     onChange={formikLogin.handleChange}
                            />
                        </div>
                        <div className={s.forgot} onClick={() => props.setCurrent(3)}>
                               Forgot password?
                        </div>
                        <div className={s.btn_block}>
                            <MyBtn
                                title={"Confirm"}
                                large
                                type={"submit"}
                                isPersonalAccountBtn
                            />
                        </div>
                        <div className={s.forget_credentials}>
                            If you forgot your login credentials, please contact&nbsp;
                            <a href="mailto:support@luxpay.lt">support@luxpay.lt</a>
                        </div>
                    </div>
                    <div className={s.dont_have_account}>
                        <div>
                            Don’t have an account?
                        </div>
                        <NavLink className={s.link} to={"/sign-up"}>Sign Up</NavLink>
                    </div>
                    <div className={s.steps}><Steps quantity={3} activeNum={0} /></div>
                </form>
            </div>
        </motion.div>
    );
};

export default SignIn;
